
import { gsap } from 'gsap';
// import { debounce as _debounce } from 'underscore';

export default class{

    constructor( options ) {
        this.defaults = {
        	main                :    null,

            js                  :   'https://cdn.sitesearch360.com/v13/sitesearch360-v13.min.js',
            siteId              :   'ayerssaintgross.com',
            searchBoxSelector   :   '.search-field',
            searchButtonSelector:   '.search-submit',

            resultSelector      :   '#ss360-target',
            searchResultTemplate:   'page-template-search',
            resultPage          :   'results',
            searchString        :   'search',

            time_reset          :   3000,

            debug               :   true,

            ajax                :   true
       };

        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'site-search-360';
		this.main			=   this.options.main;
        this.$win           =   $(window);
        this.$body          =   $( 'body' );
		
        this.home_url       =   location.protocol  + '//' + location.hostname;

        this.active = false;
        this.init( true );
    }

    init( b ){
        if ( b ){
            this.initSiteSeach360();

            if ( this.options.ajax ){
                // add a callback to main
                this.main.registerCallBack( 'barba_commons' , this, this.barba_commons  );                 
            }
       }
	}

    initSiteSeach360(){
        /* Create a configuration object */
        const ss360Config = {
            /* Your Site ID that usually equals the domain you signed up with */
            siteId: this.options.siteId,
            /* A CSS selector that points to your search box */
            searchBox: {
                selector: this.options.searchBoxSelector, 
                searchButton: this.options.searchButtonSelector,
            },

            suggestions: { show: false },
            style: { defaultCss: false },
            // tracking: { providers: ['GA'] },
            results: { 
                searchQueryParamName: this.options.searchString,
                showSearchBoxOverlay: false,
                embedConfig: {
                    'url': this.home_url  + '/' + this.options.resultPage + '/',
                    'contentBlock': '#ss360-fake-target'
                }, // if url is given, user is redirected to that page and results are inserted into the specified content block

                //moreResultsPagingSize: 24
            },
            callbacks: {
                // preSearch: function(query) { 
                //     console.log('preSearch');
                //     _this._doLoading(_this, true); return query; 
                // },
                searchResult: ( response ) => { 
                    this.onSearchResults( response ); 
                },
                searchCallback: ( response ) => { /* It looks like according to the docs that this must return true for GA tracking to work. */ return true; },
            },


        };
        window.ss360Config = ss360Config;
        this.loadScript();
    }

    loadScript(){
        let e=document.createElement("script");
        e.async =!0;
        e.src = this.options.js;
        document.getElementsByTagName("body")[0].appendChild(e);
    }

    onSearchResults( response ){
        if ( this.active ){
            return
        }
        this.active = true;
        this.response = response;

        let url = this.home_url  + '/' + this.options.resultPage + '/?' + this.options.searchString  + '=' + response.query;

        if ( this.options.ajax ){
            if ( this.isSearchResultTemplate() ){
                // if we are already on the search page ...
                this.onSearchPageReady();
                this.main.LAYOUT.openDesktopMenu( false );
                this.main.LAYOUT.openDrawerMobile( false );
            }
            else{
                // load search page (empty) via Ajax
                this.main.barba_triggerURL( url, $( this.options.searchButtonSelector ) );
                //this.main.barba_history_add(  url, $( this.options.searchButtonSelector ) );
            }            
        }
        else{
            //this.onSearchPageReady();
            //console.log(  this.response );
            if ( this.isSearchResultTemplate() ){
                this.onSearchPageReady();
                this.main.LAYOUT.openDesktopMenu( false );
                this.main.LAYOUT.openDrawerMobile( false );
            }
            else{
                document.location.href = url;
            }
        }

    }

    isSearchResultTemplate(){
        return this.$body.hasClass( this.options.searchResultTemplate );
    }

    // this is the callback from main when the search page is loaded via barba
    barba_commons( scope, mode, data  ){
        
        //console.log( 'barba_commons, mode = ' + mode + ', data = ' + data );
        
        if ( mode === 'beforeEnter' && scope.isSearchResultTemplate() ){
            //console.log( scope );
            scope.onSearchPageReady();
        }
    }

    // when the page is ready do the templating !!!
    onSearchPageReady(){
        this.doResults();
        setInterval( ()=> {
            this.active = false;
        }, this.options.time_reset );
    }

    //------------------------------------------------------------------------ OUTPUT --------------------------------------------------------------------------------//
    doResults() {
        let query = this.response;

        if ( this.options.debug ){
            //console.log( 'doResults' );
            console.log( query );
        }

        // Redirect query to specific url:
        if (query.redirect != undefined) {
            document.location.href = query.redirect;
            return;
        }

        this.changeSearchQuery();

        // No search results found:
        if (query.totalResults < 1) {
            this.output( this.template('search-template__none', {}) );
            return;
        }

        // Returned x results:
        //_this.$stats_area.html( _this.template('search-template__stats', { 'term' : query.query, 'count' : query.totalResults, }) );

        // Format search results display:
        let output_projects     = '', 
            output_people = '', 
            output_other        = '';

        // Looping over each content group:
        for (let name in query.suggests) {

            let is_projects    = (name == 'Work');
            let is_people      = (name == 'People');
            let item_template  = (is_projects) ? 'search-template__item__project' : ((is_people)?'search-template__item__people':'search-template__item__other');

            let item_title  =  name;
            if ( name == '_' ){
                item_title = 'Ideas/News/Other';
            }
 
            let output_group   = '';

            if ( query.suggests[name].length > 0 ){
                // add title to the block
                output_group += this.template( 'search-template__item__block', { 'title' : item_title } );
                // open grid
                if ( is_projects || is_people ){
                    //output_group += '<div class="grid">';
                    if ( is_people ){
                        output_group    += '<div class="grid num-' + query.suggests[name].length + '">';
                    }
                    else{
                        output_group += '<div class="grid-packery grid-project-results"><div class="gutter-sizer"></div>';
                    }
                }
            }


            // Looping over all results in group, then adding to `output_group`:
            let j=0; for (let i in query.suggests[name]) {
                let row = query.suggests[name][i];
                output_group += this.template(item_template, {
                    'link' : row.link ? row.link : row.id,
                    'thumbnail_class': this.getThumbnailClass(row, name ),
                    'image': this.getImage(row.image),
                    //'imagesize': this.getImageSize(row),
                    'title': this.getTitle(row.name),
                    'subtitle': this.getSubTitle(row),
                    'text': this.getText(row)
                });
                j++;
                if (is_people && query.suggests[name].length > 6 && j === 6 ){
                    output_group += '</div><!-- grid -->';
                    output_group += '<div class="widget-read-more" data-more="See More" data-less="See Less"><div class="grid grid-see-more text-more">';
                }


            }

            if ( query.suggests[name].length > 0 ){
                // close grid
                if ( is_projects || is_people ){
                    output_group += '</div><!-- grid -->';
                    if (is_people && query.suggests[name].length > 6 ){
                        output_group += '<div class="text-align-center block-medium"><a class="button read-more see-more">See More</a></div></div>';
                    }
                }
            }

            // Add results to correct group:
            if (is_projects) {
                output_projects = output_group;
            }
            else if(is_people){
                output_people = output_group;
            }  
            else {
                output_other = output_group;                
            }

        }

        this.output( this.template('search-template__layout', { 'projects' : output_projects, 'people' : output_people, 'other': output_other }) );

        setTimeout( () =>{

            this.main.WIDGETS.initPackeryGrids( true, $( this.options.resultSelector ), '.item-work' );
            this.main.WIDGETS.initReadMore( true, $( this.options.resultSelector ) );

        }, 17 );

    }



    //---------------------------------------- METHODS ---------------------------------------//
    // output methods //////////////////////////////////////////////////////////////////////////
    changeSearchQuery(){
        let $title = $( 'h1.headline-1' );
        $title.html( 'Search results for "' + this.response.query + '"' );
    }

    output( html ){
        let $result = $( this.options.resultSelector );

        //console.log( html );

        if ( $result.length > 0 ){

            gsap.killTweensOf( $result );

            $result.css({opacity:0}).html( html );

            if ( $result.find( '.item-work' ).length <= 0 ){
                $result.find( '.search-template-layout' ).addClass( 'no-work' );
                $result.find( '.layout-projects' ).remove();
            }
            if ( $result.find( '.item-people' ).length <= 0 ){
                $result.find( '.search-template-layout' ).addClass( 'no-people' );
                $result.find( '.layout-people' ).remove();
            }
            if ( $result.find( '.item-other' ).length <= 0 ){
                $result.find( '.search-template-layout' ).addClass( 'no-others' );
                $result.find( '.layout-others' ).remove();
            }

            gsap.to( $result, { duration: 0.4, opacity:1, ease: 'circle.easeOut' } );

        }
    }

    template(name, data) {
        var html = $('#'+name).text();
        for (let key in data) {
            var regex = new RegExp("{{" + key + "}}", "g");
            html = html.replace(regex, data[key]);
        }        
        return html;
    }


    // helper methods //////////////////////////////////////////////////////////////////////////
    getTitle(string) {
        //string = string.replace(' - Dattner Architects', '');
        return string;
    }

    getThumbnailClass(item, name){
        if ( item.dataPoints ){
            if (item.dataPoints.length) {
                for (let i in item.dataPoints) {
                    if (item.dataPoints[i]['key'] == 'thumbnail-class') {
                        return item.dataPoints[i]['value'];
                    }
                }
            }
        }
        return name==='People'?'square':'horizontal';
    }

    getSubTitle(item) {
        if ( item.dataPoints ){
            if (item.dataPoints.length) {
                for (let i in item.dataPoints) {
                    if (item.dataPoints[i]['key'] == 'subtitle') {
                        return item.dataPoints[i]['value'];
                    }
                }
            }
        }
        return '';
    }

    getText(item) {
        if ( item.dataPoints ){        
            if (item.dataPoints.length) {
                for (let i in item.dataPoints) {
                    if (item.dataPoints[i]['key'] == 'snippet') {
                        return item.dataPoints[i]['value'];
                    }
                }
            }
        }
        return item.content;
    }

    getImage(image) {
        if (image == null) {
            image = ''; //this.$body.data('theme-url') + '/assets/img/placeholder.png';
        } else {
            image = image.replace("http:", "https:");
        }
        return '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" onerror="this.style.visibility=\'hidden\'" data-src="'+ image +'" class="lazyload" data-pin-nopin="true" />';
    }

    /*
    getImageSize(item) {
        var parts       = item.link.split('/');
        var subtitle    = parts[3];
        if (parts[3] == 'people' && parts[4] == 'team' && parts[5] == 'view') {
            return 'square';
        }
        return '';
    }
    */

    destroy(){
        this.init( false );
    }

}